import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showHelpIcon)?_c(VIcon,{staticClass:"help-icon",style:(_vm.style),on:{"!click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.openHelp.apply(null, arguments)},"mousedown":function($event){$event.stopPropagation();return (() => {}).apply(null, arguments)},"touchstart":function($event){$event.stopPropagation();return (() => {}).apply(null, arguments)}}},[_vm._v("help")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }